// extracted by mini-css-extract-plugin
export var contentSection = "_e-8";
export var imageSection = "_e-1";
export var productGrid = "_e-0";
export var productImage = "_e-3";
export var productImageContainer = "_e-2";
export var productInfo = "_e-9";
export var purchaseControls = "_e-a";
export var quantityInput = "_e-c";
export var selectedThumbnail = "_e-6";
export var thumbnailContainer = "_e-4";
export var thumbnailImage = "_e-7";
export var thumbnailItem = "_e-5";
export var variantSelect = "_e-b";